import { QUERY_KEY_LIST_DEBTS } from '~/features/Debt/ListDebts'
import { useRefreshList } from '~/shared/ui/ScrollableList'

export const useRefreshPage = () => {
  const { refreshList } = useRefreshList(QUERY_KEY_LIST_DEBTS)

  const refreshPage = async () => {
    await refreshList()
  }

  return { refreshPage }
}
